import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Main site
import Nav          from './components/Nav';
import Hero         from './components/Hero';
import TrustedBy    from './components/TrustedBy';
import ShowcaseDialogs  from './components/ShowcaseDialogs';
import Services        from './components/Services';
import AIConsulting from './components/AIConsulting';
import Methodology  from './components/Methodology';
import CaseStudies  from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import Industries   from './components/Industries';
import Blog         from './components/Blog';
import About        from './components/About';
import Contact      from './components/Contact';
import Footer       from './components/Footer';

// Admin
import AdminLogin        from './pages/AdminLogin';
import AdminDashboard    from './pages/AdminDashboard';
import BlogPost          from './pages/BlogPost';
import SubmitTestimonial from './pages/SubmitTestimonial';
import ForgotPassword    from './pages/ForgotPassword';
import ResetPassword     from './pages/ResetPassword';

function MainSite() {
  return (
    <div style={{ fontFamily: "'Inter', sans-serif" }}>
      <Nav />
      <Hero />
      <TrustedBy />
      <ShowcaseDialogs />
      <Services />
      <AIConsulting />
      <Methodology />
      <CaseStudies />
      <Testimonials />
      <Industries />
      <Blog />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/admin" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"                  element={<MainSite />} />
          <Route path="/admin"                    element={<AdminLogin />} />
          <Route path="/admin/dashboard"          element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/blog/:id"                 element={<BlogPost />} />
          <Route path="/testimonials/submit"      element={<SubmitTestimonial />} />
          <Route path="/admin/forgot-password"    element={<ForgotPassword />} />
          <Route path="/admin/reset-password"     element={<ResetPassword />} />
          <Route path="*"                         element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
